import { useAppSelector } from '@store/selectors';
import { Scope } from '@tools/enums';
import { checkForScopes } from '@tools/utils';

export const useEmobilityFirmwareNotifications = () =>
    useAppSelector((state) => state.notifications.emobility.firmware);

export const useEmobilityTamperNotifications = () =>
    useAppSelector((state) => state.notifications.emobility.tamper);

export const useIsAppPromoComfortBannerVisible = () =>
    useAppSelector(
        (state) => state.notifications.appPromoComfortBanner.visible,
    );

export const useHasAppPromoComfortBannerReadScope = () =>
    checkForScopes([Scope.HOME_COMFORT_APP_PROMO_BANNER_READ]);

export const useGlobalPrompt = () =>
    useAppSelector((state) => state.notifications.globalPrompt);
